<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_sign_customer_consultant').toString()">
			<p>
				{{ $t('need_field_sign') }} <strong>{{ $t('customer_consultant') }}</strong>
				{{ $t('repair_shop_sign_customer_consultant', { repairShopType: repairShopLabel }) }}
			</p>
		</Header>

		<div class="main flex justify-around">
			<BaseSign ref="BaseInput.sign" v-model="model" />
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
			:is-back-button="true"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import BaseSign from '@/components/forms/inputs/BaseSign';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateComprehensiveSignCustomerConsultant',
	components: { BaseSign, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Validate, Authentication],
	data() {
		return {
			model: null,
		};
	},
	computed: {
		repairShopLabel() {
			if (this.isUserAllowedInLevel5) {
				return 'den Reparaturbetrieb';
			} else if (this.isUserAllowedInLevel6) {
				return 'das Autohaus';
			} else {
				return 'das Autohaus / den Reparaturbetrieb';
			}
		},
	},
	methods: {
		validate() {
			return !!this.model;
		},
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateCustomerConsultantSign', this.model);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	mounted() {
		this.model = this.$store.getters.getProcessCreateComprehensive.customerConsultantSign;
	},
};
</script>
